import type { CircularProgressProps } from '@mui/material/CircularProgress';
import MuiCircularProgress from '@mui/material/CircularProgress';
import { forwardRef } from 'react';

const CircularProgress = forwardRef<HTMLSpanElement, CircularProgressProps>(
  (props, ref) => {
    return <MuiCircularProgress ref={ref} {...props} />;
  },
);

export default CircularProgress;
